import { Component, OnInit, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '@auth/auth.service';

@Component({
  selector: 'app-mfa-register',
  templateUrl: './mfa-register.component.html',
  styleUrls: ['./mfa-register.component.scss']
})
export class MfaRegisterComponent implements OnInit {
  readonly utils = Utils;

  constructor(public activeModal: NgbActiveModal,
    private spinnerService: NgxSpinnerService,
    private authService: AuthService,
  ) {
  }

  qrCode: string | null = null;
  code: string | null = null;
  errorMessage: string | null = null;

  ngOnInit(): void {
    this.code = null;
  }

  register() {
    this.spinnerService.show().then();
    this.authService.mfaRegister(this.code)
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe(result => {
        if (result) {
          this.utils.showMessage('MFA device registered successfully.');
        }
        this.activeModal.close();
      }, err => {
        this.errorMessage = this.utils.errorMessage(err);
      });
  }
}
